import type { NextRouter } from 'next/router';

/** Shallow-set `versionFileId` so VersionFilePreviewFromQuery can open the modal. */
export function openVersionFilePreview(
  router: NextRouter,
  versionFileId: string
): void {
  const id = versionFileId.trim();
  if (!id || !router.isReady) return;

  void router.replace(
    {
      pathname: router.pathname,
      query: {
        ...router.query,
        versionFileId: id,
      },
    },
    undefined,
    { shallow: true }
  );
}
